import Page from 'flarum/common/components/Page';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class PageContent extends Page {
    oninit(){
        this.join = () => app.modal.show(LogInModal);
        this.params = new URL(window.location.href).searchParams;
        this.content = (
            <div class="error-message">
                {!app.session.user && !this.params.get('code').includes('500') && !this.params.get('code').includes('403') &&
                    <>
                      <div class="container">
                          <h1>
                              Please login to access The Clubhouse
                          </h1>
                          <p>
                              <a onclick={() =>{this.join();}}>
                                  Login to The Clubhouse
                              </a>
                          </p>
                      </div>
                  </>
                }
                {this.params.get('code').includes('404') && app.session.user &&
                    <>
                        <div class="container">
                            <h1>
                                The page you requested could not be found.
                            </h1>
                            <p>
                                <a  href="/">
                                    Return to The Clubhouse
                                </a>
                            </p>
                        </div>
                    </>
                }
                {this.params.get('code').includes('403') && !app.session.user &&
                    <>
                        <div class="container">
                            <h1>
                                You don't have permission to view this page, please login and try agin
                            </h1>
                            <p>
                                <a onclick={this.join}>
                                    Login to The Clubhouse
                                </a>
                            </p>
                        </div>
                    </>
                }
                {this.params.get('code').includes('403') && app.session.user &&
                    <>
                        <div class="container">
                            <h1>
                                You don't have permission to view this page
                            </h1>
                            <p>
                                <a  href="/">
                                   Return to The Clubhouse
                                </a>
                            </p>
                        </div>
                    </>
                }
                {this.params.get('code').includes('500') && 
                    <>
                             <div class="container">
                            <h1>
                                The server encountered an error
                            </h1>
                            <p>
                                <a href="/">
                                    Return to The Clubhouse
                                </a>
                            </p>
                        </div>
                    </>
                }
            </div>

        )

        if (app.session.user) {
            if(!this.params.get('route').includes('/admin')){
                if(this.params.get('route').includes('/d/') || this.params.get('route').includes('/t/') || this.params.get('route').includes('/tags') || this.params.get('route').includes('/following') ) {
                    if(!this.params.get('code').includes('403')) {
                        if(this.params.get('redirected') == false || this.params.get('redirected') == null){
                            window.location.href = this.params.get('route') + '?redirected=true';
                        }
                    }
                }
            } else {
                if(app.session.user.data.relationships.groups.data.filter(d => d.id == 1).length > 0) {
                    window.location.href = this.params.get('route');
                }                
            }
        }
    }


    view() {
        return this.content;
    }
}
